<template>
    <Dialog :open="open" :title="$t('notifications.notificationDetails')" max-width="900" @close="$emit('close')">
        <v-container class="pa-0">
            <v-form ref="form">
                <v-text-field :label="$t('date')" :value="formatDateTime(notification.CreatedAt)" disabled readonly/>
                <v-text-field :label="$t('notifications.title')" :value="notification.Title" disabled readonly/>
                <v-text-field :label="$t('notifications.severity')" :value="notification.Severity" disabled readonly/>
                <v-textarea :label="$t('notifications.message')" :value="notification.Text" disabled readonly rows="2"/>
                {{ $t('notifications.sentTo') }}
                <v-data-table
                        :headers="header"
                        :items="filteredRecipients"
                        :loading="loading"
                        class="rounded-lg shadow mt-2">
                    <template v-slot:[`item.AvatarUrl`]="{item}">
                        <v-avatar size="35">
                            <img
                                    v-if="item.AvatarUrl"
                                    :src="item.AvatarUrl"
                                    alt="avatar">
                            <v-icon v-else size="50">
                                mdi-account-circle
                            </v-icon>
                        </v-avatar>
                    </template>
                    <template v-slot:[`header.Channel`]>
                        <FilterDropDown
                                :key="notificationID + 'channel'"
                                v-model="filters.channels"
                                :available-values="Array.from(availableValues.channels)"
                                :filter-values="channels"
                                :name="$t('notifications.channel')"/>
                    </template>
                    <template v-slot:[`header.Status`]>
                        <FilterDropDown
                                :key="notificationID + 'status'"
                                v-model="filters.status"
                                :available-values="Array.from(availableValues.status)"
                                :filter-values="statuses"
                                :name="$t('status')"/>
                    </template>
                    <template v-slot:[`item.ViewedAt`]="{item}">
                        {{ formatDateTime(item.ViewedAt) }}
                    </template>
                </v-data-table>
            </v-form>
        </v-container>
    </Dialog>
</template>

<script>
import Dialog from "@/components/reusable/Dialog/Dialog";
import {formatDateTime} from "@/helper/helper";
import {
  CHANNEL_EMAIL,
  CHANNEL_REALTIME,
  CHANNEL_SMS,
  NOTIFICATION_COMPLETED,
  NOTIFICATION_FAILED,
  NOTIFICATION_PENDING
} from "@/helper/constants";
import FilterDropDown from "@/components/reusable/FilterDropDown/FilterDropDown";

export default {
  name: "NotificationDetails",
  components: {
    FilterDropDown,
    Dialog
  },
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    notificationID: {
      type: Number,
      required: false,
    },
    notification: {
      type: Object,
      required: true,
    }
  },
  computed: {
    filteredRecipients() {
      return this.recipients.filter((recipient) => this.filters.channels.includes(recipient.Channel) && this.filters.status.includes(recipient.Status));
    },
    header() {
      return [
        {text: this.$t('circles.avatar'), value: 'AvatarUrl'},
        {text: this.$t('authentication.firstName'), value: 'FirstName'},
        {text: this.$t('authentication.lastName'), value: 'LastName'},
        {text: this.$t('authentication.email'), value: 'Email'},
        {text: this.$t('notifications.channel'), value: 'Channel'},
        {text: this.$t('status'), value: 'Status'},
        {text: this.$t('notifications.viewedAt'), value: 'ViewedAt'},
      ];
    },
    channels() {
      return [
        {
          value: CHANNEL_SMS,
          text: this.$t('settings.SMS')
        },
        {
          value: CHANNEL_REALTIME,
          text: this.$t('settings.Realtime')
        },
        {
          value: CHANNEL_EMAIL,
          text: this.$t('settings.Email')
        },
      ];
    },
    statuses() {
      return [
        {
          value: NOTIFICATION_PENDING,
          text: this.$t('notifications.pending')
        },
        {
          value: NOTIFICATION_COMPLETED,
          text: this.$t('notifications.completed')
        },
        {
          value: NOTIFICATION_FAILED,
          text: this.$t('notifications.failed')
        },
      ];
    },
  },
  watch: {
    notificationID(id) {
      if (id) {
        this.getNotificationDetails(id);
      }
    },
  },
  mounted() {
    if (this.notificationID) {
      this.getNotificationDetails(this.notificationID);
    }
  },
  data() {
    return {
      recipients: [],
      loading: false,
      filters: {
        channels: [],
        status: [],
      },
      availableValues: {
        channels: new Set(),
        status: new Set(),
      },
    };
  },
  methods: {
    formatDateTime,
    getNotificationDetails(id) {
      const url = this.$store.getters.notificationRecipients(id);
      this.loading = true;
      this.recipients = [];
      this.axios.get(url).then(({data}) => {
        const recipients = data.Result;
        recipients.forEach(recipent => {
          recipent.Channels.forEach(channel => {
            this.recipients.push({...recipent, Channel: channel.Channel, Status: channel.Status})
          })
        })
        this.availableValues.channels.clear();
        this.availableValues.status.clear();
        this.recipients.forEach(recipient => {
          this.availableValues.channels.add(recipient.Channel);
          this.availableValues.status.add(recipient.Status);
        });
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>

</style>